import React from "react";
import { Link } from "react-router-dom";
import InstrumentCard from "../../components/InstrumentCard/InstrumentCard";
import guitar from "../../assets/img/guitar.jpg";
import violence from "../../assets/img/violence.jpg";
import drums from "../../assets/img/drums.jpg";
import saxophone from "../../assets/img/saxophone.jpg";
import hero from "../../assets/img/fone.jpg";
import style from "./Main.module.css";
import { useI18n } from "../../i18n/I18n";

function Home(): JSX.Element {
  const { t } = useI18n();
  const categories = [
    { img: guitar, title: t("guitars"), caption: t("guitarsCaption") },
    { img: violence, title: t("violins"), caption: t("violinsCaption") },
    { img: drums, title: t("drums"), caption: t("drumsCaption") },
    { img: saxophone, title: t("winds"), caption: t("windsCaption") },
  ];
  return (
    <div className="wrapper">
      <section className={style.hero}>
        <div className={`container ${style.heroGrid}`}>
          <div className={style.heroCopy}>
            <p className="eyebrow">{t("heroEyebrow")}</p>
            <h1>{t("heroTitle")}</h1>
            <p className={style.lead}>{t("heroLead")}</p>
            <div className={style.actions}>
              <Link className="button" to="/instruments">{t("viewCatalog")}</Link>
              <Link className={style.textLink} to="/order">{t("createOwn")}</Link>
            </div>
            <div className={style.proofs}><span><b>12+</b> {t("yearsExperience")}</span><span><b>300</b> {t("instruments")}</span><span><b>14</b> {t("returnDays")}</span></div>
          </div>
          <div className={style.heroVisual}>
            <img src={hero} alt={t("musicianAlt")} />
            <div className={style.floating}><span>{t("weeklyChoice")}</span><b>{t("liveSound")}</b></div>
          </div>
        </div>
      </section>
      <section className={style.catalog}>
        <div className="container">
          <div className={style.sectionHead}><div><p className="eyebrow">{t("catalog")}</p><h2>{t("startSound")}</h2></div><Link to="/instruments">{t("fullCatalog")}</Link></div>
          <div className={style.cards}>{categories.map((item) => <InstrumentCard key={item.title} {...item} />)}</div>
        </div>
      </section>
      <section className={style.custom}>
        <div className={`container ${style.customInner}`}>
          <div><p className="eyebrow">{t("workshop")}</p><h2>{t("uniqueTitle")}</h2></div>
          <div><p>{t("uniqueLead")}</p><Link className="button" to="/order">{t("openBuilder")}</Link></div>
        </div>
      </section>
    </div>
  );
}
export default Home;
